var map = {
	"../mts/company/company.module": [
		"./src/app/mts/company/company.module.ts",
		"default~mts-company-company-module~mts-person-person-module~mts-user-user-module~pss-offer-offer-mod~a6d352ba",
		"default~mts-company-company-module~pss-offer-offer-module",
		"common"
	],
	"../mts/followoffers/statistics.module": [
		"./src/app/mts/followoffers/statistics.module.ts",
		"common",
		"mts-followoffers-statistics-module"
	],
	"../mts/followorders/statistics.module": [
		"./src/app/mts/followorders/statistics.module.ts",
		"common",
		"mts-followorders-statistics-module"
	],
	"../mts/group/group.module": [
		"./src/app/mts/group/group.module.ts",
		"common",
		"mts-group-group-module"
	],
	"../mts/lang/lang.module": [
		"./src/app/mts/lang/lang.module.ts",
		"mts-lang-lang-module"
	],
	"../mts/person/person.module": [
		"./src/app/mts/person/person.module.ts",
		"default~mts-company-company-module~mts-person-person-module~mts-user-user-module~pss-offer-offer-mod~a6d352ba",
		"common"
	],
	"../mts/references/references.module": [
		"./src/app/mts/references/references.module.ts",
		"default~mts-references-references-module~pss-job-order-job-order-module~pss-offer-offer-module",
		"common",
		"mts-references-references-module"
	],
	"../mts/statistics/statistics.module": [
		"./src/app/mts/statistics/statistics.module.ts",
		"common",
		"mts-statistics-statistics-module"
	],
	"../mts/statisticsadv/statistics.module": [
		"./src/app/mts/statisticsadv/statistics.module.ts",
		"common",
		"mts-statisticsadv-statistics-module"
	],
	"../mts/user/user.module": [
		"./src/app/mts/user/user.module.ts",
		"default~mts-company-company-module~mts-person-person-module~mts-user-user-module~pss-offer-offer-mod~a6d352ba",
		"common"
	],
	"../pss/job-order/job-order.module": [
		"./src/app/pss/job-order/job-order.module.ts",
		"default~mts-references-references-module~pss-job-order-job-order-module~pss-offer-offer-module",
		"common",
		"pss-job-order-job-order-module"
	],
	"../pss/my-offers/my-offers.module": [
		"./src/app/pss/my-offers/my-offers.module.ts",
		"pss-my-offers-my-offers-module"
	],
	"../pss/offer/offer.module": [
		"./src/app/pss/offer/offer.module.ts",
		"default~mts-company-company-module~mts-person-person-module~mts-user-user-module~pss-offer-offer-mod~a6d352ba",
		"default~mts-references-references-module~pss-job-order-job-order-module~pss-offer-offer-module",
		"default~mts-company-company-module~pss-offer-offer-module",
		"common",
		"pss-offer-offer-module"
	],
	"../rmp/material/material.module": [
		"./src/app/rmp/material/material.module.ts",
		"rmp-material-material-module"
	],
	"../scs/cis/cis.module": [
		"./src/app/scs/cis/cis.module.ts",
		"scs-cis-cis-module"
	],
	"../scs/constitution/constitution.module": [
		"./src/app/scs/constitution/constitution.module.ts",
		"common",
		"scs-constitution-constitution-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"common",
		"dashboard-dashboard-module"
	],
	"./index/index.module": [
		"./src/app/dashboard/index/index.module.ts",
		"index-index-module"
	],
	"./mts/login/login.module": [
		"./src/app/mts/login/login.module.ts",
		"mts-login-login-module"
	],
	"./not-found/not-found.module": [
		"./src/app/not-found/not-found.module.ts",
		"not-found-not-found-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;